import styles from "./Header.module.css";
import arch1 from '../../../assets/images/home-page-slider-2.jpg';
const HomePageHeader = () => {
    return (
        <>
            <div className={`${styles.header}`}>
                <div className={`${styles.container}`}>
                    <div className={`${styles.box}`}>
                        <div className="section-title">
                            <div className="title-heade">
                                <h3>Modern Luxury: Where Sophistication Meets Innovation</h3>
                            </div>
                        </div>
                        <div>
                            <h1 className={`${styles.heading}`}>An Innate Talent for</h1>
                            <h1 className={`${styles.heading}`}><span className={`${styles.subtext}`}>Design Excellence</span></h1>
                        </div>
                        <p className={`${styles.description}`}>
                            At Kritajna Homes, luxury isn’t just about extravagance—it’s about curating spaces that merge sophistication with purpose.
                            <br />
                            With an intuitive approach to design, we craft interiors that resonate with individuality and timeless appeal, turning spaces into personalized sanctuaries.
                        </p>
                    </div>
                </div>
                <div className={`${styles.image}`}>
                    <img className={`${styles.img}`} src={arch1} alt="" />
                </div>
            </div>
            <div className={`${styles.empty}`}>
            </div>
        </>
    );
}

export default HomePageHeader;